import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpRequestDecorator } from '../core/triggerbee/http.request.decorator';
import { TriggerbeeApi } from '../core/triggerbee/triggerbee-api.enum';
import { EmailTemplate } from './models/email-template.model';

@Injectable({ providedIn: 'root' })
export class EmailTemplateService {
  private readonly http = inject(HttpRequestDecorator);

  private getResource(customerId: string, id?: string): string {
    const base = `${this.http.getBaseUrl(TriggerbeeApi.Gateway)}/email-templates/customers/${customerId}`;
    return id ? `${base}/${id}` : base;
  }

  public getByCustomer(customerId: string): Observable<EmailTemplate[]> {
    return this.http.get(this.getResource(customerId));
  }

  public getAll(): Observable<EmailTemplate[]> {
    return this.http.get(`${this.http.getBaseUrl(TriggerbeeApi.Gateway)}/email-templates`);
  }

  public getById(customerId: string, id: string): Observable<EmailTemplate> {
    return this.http.get(this.getResource(customerId, id));
  }

  public create(customerId: string, template: EmailTemplate): Observable<EmailTemplate> {
    return this.http.post(this.getResource(customerId), template);
  }

  public update(customerId: string, id: string, template: EmailTemplate): Observable<EmailTemplate> {
    return this.http.put(this.getResource(customerId, id), template);
  }

  public delete(customerId: string, id: string): Observable<unknown> {
    return this.http.delete(this.getResource(customerId, id));
  }

  public sendTestEmail(customerId: string, templateId: string): Observable<unknown> {
    const url = `${this.http.getBaseUrl(TriggerbeeApi.Gateway)}/transactional-emails/${templateId}/send/test`;
    return this.http.post(url, { customerId });
  }
}
